import templateHelpers from './template-helpers';
import { adams } from 'app/scripts/lib/adams';

export const teacupWithHelpers = templateHelpers(adams);
